import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

export interface IRichTextColumn extends ITableColumn {
  Settings: null
}

export interface IRictTextCell extends ICell {
  settings: null
}

export class RichTextCell implements IRictTextCell {
  value: Cell
  settings: null
  constructor(value: Cell, settings: null) {
    this.value = value
    this.settings = settings
  }

  toString(): string {
    return this.value !== null && this.value !== undefined ? this.value.toString() : ''
  }

  toCell<T extends Cell>(newValue: T) {
    if (!newValue || typeof newValue !== 'string') {
      this.value = ''
      return this
    }
    this.value = newValue
    return this
  }
}
